import { DetailScrollReveal } from '~/ui-rocco/pages/detail-shared';
import { ProfessionalArticlesSection } from './sections/ProfessionalArticlesSection';
import { ProfessionalContactSection } from './sections/ProfessionalContactSection';

/**
 * BC-4572 — revamped professional Articles tab (/journal).
 *
 * Reuses the overview revamp's sections (hero, sub-nav, articles grid, the
 * "Talk to us" block and the About-ArchiPro closing) so the tab matches the
 * root detail page. Rendered behind the same revamp flag; the journal route
 * serves overview-shaped loader data so these sections get what they expect.
 */
export const ProfessionalArticlesPageRevamp = () => {
    return (
        <main
            id="main-content"
            data-testid="professional-articles-page-revamp"
            className="bg-ground ground-grey max-md:pb-16 md:pb-[6.25rem]"
        >
            <DetailScrollReveal>
                <ProfessionalArticlesSection variant="tab" />
            </DetailScrollReveal>
            <ProfessionalContactSection />
        </main>
    );
};
